import { Post } from '@wellesley/openapi'

const isRepost = (feed: Post) =>
  !!feed?.stats?.reposts || !!feed.repostedBy?.length

export default isRepost
